<template>
  <div class="text-xs-center">
    <v-dialog persistent width="700" v-model="dialog">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t("navigation.archive") }}
        </v-card-title>
        <v-card-text>
          <v-layout>
          <v-flex xs2>
              <img class="pointer" @click="open(archive.id)" v-if="archive != null " style="width:100%" :src="'data:image/jpg;base64,'+archive.thumbImg" />
          </v-flex>
          <v-flex xs8 offset-xs1 >
          <v-text-field width="80%" v-model="archvieCopy.customName" :label="`${$t('archive.file-name')}`" required></v-text-field>
          <v-text-field width="80%" v-model="archvieCopy.archType" :label="`${$t('archive.arch_type')}`" required></v-text-field>
          </v-flex>
          </v-layout>
          <v-textarea clear-icon="cancel" :label="`${$t('archive.text')}`" v-model="archvieCopy.text" required></v-textarea>
          <v-textarea clear-icon="cancel" :label="`${$t('archive.note')}`" v-model="archvieCopy.note" required></v-textarea>
        </v-card-text>


        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
          <v-btn color="blue darken-1" flat @click="cancel">{{ $t('cyclic.abort') }}</v-btn>
          <v-btn v-if="edit" color="primary" @click="upload" :disabled="loading">
            {{ $t('archive.filter.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <img @click="dialog=!dialog" v-if="archive != null " class="imageField" :src="'data:image/jpg;base64,'+archive.thumbImg" />

      </div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputHelper from  '@/plugins/InputHelper'
import fieldType from '@/enums/fieldType'
import http from '@/plugins/http'
import DataTimeHelper from '@/plugins/DataTimeHelper'

export default {
  props: ["archive","edit"],
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      dialog: false,
      archvieCopy:{},
      loading:false

    }
  },
  methods: {
    upload() {
      if (this.archive.customName.length > 3) {
        this.loading = true
        http.put('archive/' + this.archive.id, this.archvieCopy).then(() => {
          this.archive.note = this.archvieCopy.note
          this.archive.archType = this.archvieCopy.archType
          this.archive.customName = this.archvieCopy.customName
          this.archive.text = this.archvieCopy.text
          this.archive.modifyTime=DataTimeHelper.getDateTime()
          this.archive.modifyTime=DataTimeHelper.getDateTime()
          this.dialog = false
        }).catch(() => {}).finally(() => this.loading = false)
      }
    },
    cancel() {
      this.archvieCopy={...this.archive}
      this.loading = false
      this.dialog=false
    },
    open(id) {
      this.$store.commit("setSnack", {
        message: this.$t('archive.image_downloading'),
        color: "success",
        timeout: 1000
      })

      http.get('archives/show/' + id).then(data => {
        if (data.data.type == "image/tiff") {
          window.open('data:' + data.data.type + ";base64," + encodeURI(data.data.data), '_blank');
        } else {
          let win = window.open("")
          win.document.write('<iframe width=\'100%\' height=\'100%\' src=\'data:' + data.data.type + ";base64," + encodeURI(data.data.data) + "'></iframe>");
        }
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t('archive.image_error'),
          color: "success",
        })
      })
    },
  },
  created(){
    this.archvieCopy={...this.archive}
  }
}
</script>

<style scope>
.radio >  label{
  font-size: 11px !important;
}
.radio{

}
.imageField{
    height:100px;
    cursor:pointer;
    /*transform: rotate(-90deg);*/
}
.pointer{
      cursor:pointer;
}
</style>
